(function () {
  angular.module("akitabox.desktop.components.relatedWorkOrderCard", [
    "720kb.tooltips",
  ]);
})();
